export enum RequestFormSubview {
    FORM_DESIGNER,
    SETTINGS,
    SUBMISSIONS,
}